export const iconFontAwesomeHumanitarianVialCircleCheck = (
	<i className="fa-solid fa-vial-circle-check"></i>
);
